import { Component, NgModule, OnInit, Input } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {MatStepperModule} from '@angular/material/stepper';
import {FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material';
import { Homepage } from '../homepage/homepage';

@Component({
  selector: 'app-steps-landing',
  templateUrl: './steps-landing.html',
  styleUrls: ['./steps-landing.scss']
})
export class StepsLanding implements OnInit {

    @Input() homepage : Homepage;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;
  
    constructor(private _formBuilder: FormBuilder) {}

    ngOnInit() {
        this.firstFormGroup = this._formBuilder.group({
          firstCtrl: ['', Validators.required]
        });
        this.secondFormGroup = this._formBuilder.group({
          secondCtrl: ['', Validators.required]
        });
        this.thirdFormGroup = this._formBuilder.group({
            thirdCtrl: ['', Validators.required]
        });
      }
}

@NgModule({
  imports: [ MatIconModule, MatButtonModule, MatToolbarModule, CdkStepperModule, MatStepperModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule ],
  exports: [ StepsLanding ],
  declarations: [ StepsLanding ],
})
export class StepsLandingModule {}